import { buildApiUrl, ADMIN_ENDPOINTS } from '../../configs/api.js'

export default {
  url(payload) {
    return buildApiUrl(ADMIN_ENDPOINTS.USER_ADMIN_REGISTER || '/user/rapidoo-admin/register')
  },

  method() {
    return 'POST'
  },

  format(payload) {
    return {
      firstName: payload.firstName,
      lastName: payload.lastName,
      password: payload.password,
      email: payload.email,
      countryCode: payload.countryCode || 'BJ',
    }
  },

  parse(raw = {}) {
    if (raw.statusCode !== 201 && raw.statusCode !== 200) {
      return {
        statusCode: raw?.statusCode || 400,
        message: raw?.message || "Erreur lors de la création de l'utilisateur",
        data: null,
      }
    }

    return {
      statusCode: 200,
      message: 'Utilisateur créé avec succès',
      data: raw.data,
    }
  },
}
